<template>
	<div class="sample-page">
		<div class="breadcrumb">
			<a-breadcrumb>
				<a-breadcrumb-item>
					<router-link to="/home">首页</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>
					<router-link to="/sufferer">患者管理</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>患者详情</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="wei_detail">
			<div class="header">
				<a-row>
					<a-col :span="12">
						<span class="name">{{detail.patientName}}</span>
						<span class="sex">
							<a-icon type="man" v-if="detail.sexName=='男'"/>
							<a-icon type="woman" v-if="detail.sexName=='女'"/>
							<span class="fr wei_soan_sex" @click="edit()" v-auth="'21321'">编辑</span>
							<span class="set-text">{{detail.sexName}}</span>
						</span>
					</a-col>
					<a-col :span="12" class="w-text-right">
						<a-button @click="merge()" type="primary" v-auth="'1010511'" v-if="detail.mergeFlag == 1">合并患者</a-button>
					</a-col>
				</a-row>
				<div class="wei_header_box">
					<a-row class="w-pb20">
						<a-col :span="2" class="w-text-right">
							身份证号：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.patientCardNo||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							出生日期：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.ageBirthDay||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							数据库ID：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail. clinicalDbId||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							初次就诊年龄：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.firstSeeDoctorAge||'-'}}
						</a-col>
					</a-row>
					<a-row class="w-pb20">
						<a-col :span="2" class="w-text-right">
							分组：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.groupName||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							疾病类型：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.diseaseType||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							籍贯：
						</a-col>
						<a-col :span="10" class="w-text-left">
							<span class="right-group-value">
                <span v-if='detail.province'>
                    <span v-if='detail.city'>
                      <span v-if='detail.country'>{{detail.provinceName + '/'+detail.cityName +'/'+ detail.countryName}}</span>
                      <span v-else>{{detail.provinceName + '/' +detail.cityName}}</span>
                    </span>
                    <span v-else>{{detail.provinceName}}</span>
                  </span>
                <span v-else>-</span>
              </span>
						</a-col>
					</a-row>
					<a-row class="w-pb20">
						<a-col :span="2" class="w-text-right">
							父亲姓名：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.fatherName||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							父亲手机号：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.fatherPhone||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							母亲姓名：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.motherName||'-'}}
						</a-col>
						<a-col :span="2" class="w-text-right">
							母亲手机号：
						</a-col>
						<a-col :span="4" class="w-text-left">
							{{detail.motherPhone||'-'}}
						</a-col>
					</a-row>
				</div>
			</div>
		</div>
		<div class="page-content">
			<div class="panel-page panel-page2">
				<div class="panel-title">
					<div :class="{'active':process==1}" @click="currentProcess()">当前流程</div>
					<div :class="{'active':process==2}" @click="historyProcess()">历史流程</div>
				</div>
				<div class="panel-tip" v-if="process==1">
					<div class="content-item">
						<a-table
              :columns="columns"
              :rowKey="record => record.id"
              :dataSource="data"
              :pagination="pagination"
              :expandedRowKeys="spandIndex"
              @expandedRowsChange="expandedRowsChange"
						>
							<!-- <a slot="action" slot-scope="text,record" href="javascript:;">Delete</a> -->
							<span slot="operateDate" class="operate-more" slot-scope="text, record">
                <span v-auth="'1010503'" @click="finishIt(record)">
                  <a-button
                    type="default"
                    v-auth="'1010503'"
                    style="background:none;border:0 none;font-size:12px"
                    :disabled="record.urlList==null||record.trackingStatus=='to-be-re-approval'||record.trackingStatus =='completed'"
                    class="cursor"
                  >确认完成</a-button>
                </span>
								<!-- <span v-auth="'1010503'" v-if="record.urlList==null" class="cursor blue mr">报告未提交</span> -->
                <span class="handle-more">
                  <a-dropdown
                    :trigger="['click']"
                    overlayClassName="hospital-dropdown-table"
                    class="hospital-dropdown-link"
                  >
                    <a class="ant-dropdown-link">
                      <i class="icon-gengduo iconfont"></i>
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a-button
                          type="default"
                          v-auth="'1010504'"
                          style="width:100%;padding:0 5px;"
                          :disabled="record.trackingStatus!='wait-add-item'&&record.trackingStatus!='added-item'&&record.trackingStatus!='confirmed-requisition'&&record.trackingStatus!='handover'&&record.trackingStatus!='experiment'&&record.trackingStatus!='already-up-compute'&&record.trackingStatus!='fq-to-be-uploaded'"
                          @click="endIt(record)"
                        >终止流程</a-button>
                      </a-menu-item>
                      <a-menu-item>
                        <a-button
                          type="default"
                          v-auth="'1010505'"
                          style="width:100%;padding:0 5px;"
                          :disabled="record.urlList==null||record.trackingStatus=='to-be-re-approval'||record.trackingStatus =='completed'"
                          @click="reviewIt(record)"
                        >申请退回</a-button>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </span>
              </span>
							<span slot="qualityStatus" slot-scope="text, record">
                <span v-if="record.qualityStatus=='1'">合格</span>
                <span v-if="record.qualityStatus=='2'">
                   <a-popover title="原因">
                      <div style="max-width:300px;" slot="content">{{record.qualityRemark}}</div>
                      <span class="link">不合格</span>
                    </a-popover>
	                <!-- 不合格
					        <span class="cursor blue ml" @click="showReason(record)">(原因)</span> -->
                </span>
                <span v-if='record.qualityStatus!="1"&&record.qualityStatus!="2"'>-</span>
              </span>
							<span slot="bid" slot-scope="text, record">
                <!-- <router-link v-auth="'1010501'" v-if="record.bid"
                     :to="{path:'/report/details',query:{id:record.id}}">预览&nbsp;|
                </router-link>
                <a v-auth="'1010502'" v-if="record.bid" :href="record.bid">下载</a>
                <span v-if="!record.bid">-</span>-->
								<!-- {{record}} -->
                <span v-if="record.urlList!=null">
                  <a v-if="record.bid" v-auth="'1010501'" href="#" @click="preview(record.urlList)">预览&nbsp;|</a>
                  <a v-if="record.bid" v-auth="'1010502'" @click="down(record.urlList)" href="#">下载</a>
                  <span v-if="!record.bid">-</span>
                </span>
                <span v-if="record.urlList==null">
                  <!-- <button disabled>预览</button>
                  <button disabled>下载</button>-->
                  <span>报告未提交</span>
                  <span v-if="!record.bid">-</span>
                </span>
              </span>
							<div slot="expandedRowRender" slot-scope="record" style="margin: 0">
								<div class="steps-div-content">
									<h-process :bid="record.id" :IsSuffer="record.trackingStatus =='waiting'?1:0">
										<div style="margin:0 auto; width:600px;padding:30px 0;">
											<a-steps direction="vertical" size="small" :current="1">
												<a-step title="Finished" description="This is a description."/>
												<a-step title="In Progress" description="This is a description."/>
												<a-step title="Waiting" description="This is a description."/>
											</a-steps>
										</div>
									</h-process>
								</div>
							</div>
						</a-table>
					</div>
				</div>
				<div class="panel-tip" v-if="process==2">
					<div class="content-item">
						<a-table
              class="hospital-table-detail"
              :columns="column"
              :dataSource="datas"
              :pagination="pagination"
              :rowKey="record => record.id"
              :expandedRowKeys="spandIndex"
              @expandedRowsChange="expandedRowsChange"
              size="small"
						>
							<a slot="action" slot-scope="text,record" href="javascript:;">Delete</a>
							<span slot="qualityStatus" slot-scope="text, record">
                <span v-if="record.qualityStatus=='1'">合格</span>
                <span v-if="record.qualityStatus=='2'">
                   <a-popover title="原因">
                      <div style="max-width:300px;" slot="content">{{record.qualityRemark}}</div>
                      <span class="link">不合格</span>
                    </a-popover>
	                <!-- 不合格
					        <span class="cursor blue ml" @click="showReason(record)">(原因)</span> -->
                </span>
                <span v-if='record.qualityStatus!="1"&&record.qualityStatus!="2"'>-</span>
              </span>
							<span slot="operateDate" slot-scope="text, record">
                <span v-auth="'1010506'" class="cursor blue mr" v-if='record.trackingStatus!="completed"'
                      @click="refinishIt(record)">恢复流程</span>
                <span v-auth="'1010506'" v-if='record.trackingStatus=="completed"'>恢复流程</span>
              </span>

							<span slot="bid" slot-scope="text, record">
                <span v-if="record.urlList!=null">
                  <a herf="#" v-auth="'1010501'" v-if="record.bid" @click="preview(record.urlList)">预览&nbsp;|</a>
                  <a v-if="record.bid" v-auth="'1010502'" @click="down(record.urlList)" herf="#">下载</a>
                  <span v-if="!record.bid">-</span>
                </span>
                <span v-if="record.urlList==null">
                  <span>
                    <a-button style="border:0 none;background:none" type='default' disabled>预览|下载</a-button>
                  </span>
	                <!-- <span>
                    <button disabled>下载</button>
                  </span> -->
                  <span v-if="!record.bid">-</span>
                </span>
              </span>
							<div slot="expandedRowRender" slot-scope="record" style="margin: 0">
								<div class="steps-div-content">
									<h-process :bid="record.id" :IsSuffer="record.trackingStatus =='waiting'?1:0">
										<div style="margin:0 auto; width:600px;padding:30px 0;">
											<a-steps direction="vertical" size="small" :current="1">
												<a-step title="Finished" description="This is a description."/>
												<a-step title="In Progress" description="This is a description."/>
												<a-step title="Waiting" description="This is a description."/>
											</a-steps>
										</div>
									</h-process>
								</div>
							</div>
						</a-table>
					</div>
				</div>
			</div>
		</div>
		<div class="page-content" style="border-top:1px solid #F6F7F9">
			<div class="panel-page panel-page2">
				<div class="panel-title">
					<div @click="currentProcess()" style="padding:0;">样本信息</div>
				</div>
				<div class="panel-tip">
					<div class="content-item">
						<a-table
              :columns="column2"
              :rowKey="record => record.id"
              :dataSource="data2"
              :pagination="pagination"
						>
							<span
                slot="operateDate"
                v-auth="'1010508'"
                slot-scope="text,record"
                class="link"
                @click="goToSample(record)"
							>流转记录
							</span>
						</a-table>
					</div>
				</div>
			</div>
		</div>
		<div class="page-content" style="border-top:1px solid #F6F7F9">
			<div class="panel-page panel-page2">
				<div class="panel-title">
					<div style="padding:0;">患者合并历史</div>
				</div>
				<div class="panel-tip">
					<div class="content-item">
						<a-table
								:columns="columns3"
								:rowKey="record => record.id"
								:dataSource="mergeRecordData"
								:pagination="false"
						>
						</a-table>
					</div>
				</div>
			</div>
		</div>

		<page-model @close="closeModel" :visible="visible">
			<edit v-if="visible" :list="detail" @update="update" @close="closeModel"></edit>
		</page-model>
		<reason v-if="visible_reason" @update="update" :reason="reason" @close="closeModel"></reason>
		<page-model @close="closeModel" :visible="visible_finish">
			<finish v-if="visible_finish" @update="update" :finish="finish" @close="closeModel"></finish>
		</page-model>
		<page-model @close="closeModel" :visible="visible_refinish">
			<refinish v-if="visible_refinish" @update="update" :refinish="refinish" @close="closeModel"></refinish>
		</page-model>
		<page-model @close="closeModel" :visible="visible_end">
			<end v-if="visible_end" @update="update" :end="end" @close="closeModel"></end>
		</page-model>
		<page-model @close="closeModel" :visible="visible_review">
			<review v-if="visible_review" @update="update" :review="review" @close="closeModel"></review>
		</page-model>
		<page-model @close="closeModel" :visible="visible_marge">
			<merge v-if="visible_marge" :recordMerge="detail" @getData="update" @close="closeModel"></merge>
		</page-model>
	</div>
</template>

<script>
  import HProcess from "@/components/common/process.vue";
  import Edit from "./edit";
  import Reason from "./reason";
  import Finish from "./finish";
  import Refinish from "./refinish";
  import End from "./end";
  import Review from "./review";
  import Merge from "./merge";
  import moment from 'moment';
  import auth from "../../directives/auth-utils";

  const columns = [
    {
      title: "协作组条码",
      dataIndex: "hosBarCode",
      customRender: (text, record, index) => {
        if (!record.hosBarCode) {
          return "-";
        } else {
          return record.hosBarCode;
        }
      }
    },
    {
      title: "就诊医院",
      dataIndex: "hospitalName",
      customRender: (text, record, index) => {
        if (!record.hospitalName) {
          return "-";
        } else {
          return record.hospitalName;
        }
      }
    },
    {
      title: "门诊号",
      dataIndex: "patientNo",
      customRender: (text, record, index) => {
        if (!record.patientNo) {
          return "-";
        } else {
          return record.patientNo;
        }
      }
    },
    {
      title: "就诊日期",
      dataIndex: "seeDoctorTime",
      customRender: (text, record, index) => {
        if (!record.seeDoctorTime) {
          return "-";
        } else {
          return record.seeDoctorTime;
        }
      }
    },
    {
      title: "测序中心",
      dataIndex: "deptName",
      customRender: (text, record, index) => {
        if (!record.deptName) {
          return "-";
        } else {
          return record.deptName;
        }
      }
    },
    {
      title: "测序中心条码",
      dataIndex: "barCode",
      customRender: (text, record, index) => {
        if (!record.barCode) {
          return "-";
        } else {
          return record.barCode;
        }
      }
    },
    {
      title: "检验项目",
      dataIndex: "applyItemNameDict",
      customRender: (text, record, index) => {
        if (!record.applyItemNameDict) {
          return "-";
        } else {
          return record.applyItemNameDict;
        }
      }
    },
    {
      title: "专业组",
      dataIndex: "groupName",
      customRender: (text, record, index) => {
        if (!record.groupName) {
          return "-";
        } else {
          return record.groupName;
        }
      }
    },
    // 样本类型:"sampleTypeNameDict", 样本量:"sampleAmount"
    {
      title: "质检状态",
      dataIndex: "qualityStatus",
      scopedSlots: {
        customRender: "qualityStatus"
      }
    },
    {
      title: "报告",
      width: 100,
      dataIndex: "bid",
      scopedSlots: {
        customRender: "bid"
      }
    },
    {
      title: "操作",
      dataIndex: "operateDate",
      scopedSlots: {
        customRender: "operateDate"
      }
    }
  ];

  const column = [
    {
      title: "协作组条码",
      dataIndex: "hosBarCode",
      customRender: (text, record, index) => {
        if (!record.hosBarCode) {
          return "-";
        } else {
          return record.hosBarCode;
        }
      }
    },
    {
      title: "流程id",
      dataIndex: "id",
      customRender: (text, record, index) => {
        if (!record.id) {
          return "-";
        } else {
          return record.id;
        }
      }
    },
    {
      title: "就诊医院",
      dataIndex: "hospitalName",
      customRender: (text, record, index) => {
        if (!record.hospitalName) {
          return "-";
        } else {
          return record.hospitalName;
        }
      }
    },
    {
      title: "门诊号",
      dataIndex: "patientNo",
      customRender: (text, record, index) => {
        if (!record.patientNo) {
          return "-";
        } else {
          return record.patientNo;
        }
      }
    },
    {
      title: "就诊日期",
      dataIndex: "seeDoctorTime",
      customRender: (text, record, index) => {
        if (!record.seeDoctorTime) {
          return "-";
        } else {
          return record.seeDoctorTime;
        }
      }
    },
    {
      title: "检验项目",
      dataIndex: "applyItemNameDict",
      customRender: (text, record, index) => {
        if (!record.applyItemNameDict) {
          return "-";
        } else {
          return record.applyItemNameDict;
        }
      }
    },
    {
      title: "结束日期",
      dataIndex: "endTime",
      customRender: (text, record, index) => {
        if (!record.endTime) {
          return "-";
        } else {
          return record.endTime;
        }
      }
    },
    {
      title: "质检状态",
      dataIndex: "qualityStatus",
      scopedSlots: {
        customRender: "qualityStatus"
      }
    },
    {
      title: "报告",
      dataIndex: "bid",
      scopedSlots: {
        customRender: "bid"
      }
    },
    {
      title: "操作",
      dataIndex: "operateDate",
      scopedSlots: {
        customRender: "operateDate"
      }
    }
  ];

  const column2 = [
    {
      title: "流转机构",
      dataIndex: "deptName",
      customRender: (text, record, index) => {
        if (!record.deptName) {
          return "-";
        } else {
          return record.deptName;
        }
      }
    },
    {
      title: "样本编号",
      dataIndex: "sampleId",
      customRender: (text, record, index) => {
        if (!record.sampleId) {
          return "-";
        } else {
          return record.sampleId;
        }
      }
    },
    {
      title: "样本类型",
      dataIndex: "sampleTypeNameDict",
      customRender: (text, record, index) => {
        if (!record.sampleTypeNameDict) {
          return "-";
        } else {
          return record.sampleTypeNameDict;
        }
      }
    },
    {
      title: "样本量",
      dataIndex: "sampleAmount",
      customRender: (text, record, index) => {
        if (!record.sampleAmount) {
          return "-";
        } else {
          return record.sampleAmount;
        }
      }
    },
    {
      title: "操作类型",
      dataIndex: "operateStatusDict",
      customRender: (text, record, index) => {
        if (!record.operateStatusDict) {
          return "-";
        } else {
          return record.operateStatusDict
        }
      }

    },
    {
      title: "操作时间",
      dataIndex: "optTime",
      customRender: (text, record, index) => {
        if (!record.optTime) {
          return "-";
        } else {
          return moment(record.optTime).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    {
      title: "操作",
      dataIndex: "operateDate",
      scopedSlots: {
        customRender: "operateDate"
      }
    }
  ];
  const columns3 = [
    {
      title: "序号",
      customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "患者姓名",
      dataIndex: "patientName",
      customRender: (text, record, index) => {
        if (!record.patientName) {
          return '-'
        } else {
          return record.patientName
        }
      }
    },
    {
      title: "性别",
      dataIndex: "sexName",
      customRender: (text, record, index) => {
        if (!record.sexName) {
          return '-'
        } else {
          return record.sexName
        }
      }
    },
    {
      title: "数据库ID",
      dataIndex: "clinicalDbId",
      customRender: (text, record, index) => {
        if (!record.clinicalDbId) {
          return '-'
        } else {
          return record.clinicalDbId
        }
      }
    },
    {
      title: "身份证号码",
      dataIndex: "patientCardNo",
      customRender: (text, record, index) => {
        if (!record.patientCardNo) {
          return '-'
        } else {
          return record.patientCardNo
        }
      }
    },
    {
      title: "出生日期",
      dataIndex: "ageBirthDay",
      customRender: (text, record, index) => {
        if (!record.ageBirthDay) {
          return '-'
        } else {
          return record.ageBirthDay
        }
      }
    },
    {
      title: "疾病类型",
      dataIndex: "diseaseType",
      customRender: (text, record, index) => {
        if (!record.diseaseType) {
          return '-'
        } else {
          return record.diseaseType
        }
      }
    },
    {
      title: "分组",
      dataIndex: "groupName",
      customRender: (text, record, index) => {
        if (!record.groupName) {
          return '-'
        } else {
          return record.groupName
        }
      }
    },
    {
      title: "籍贯",
      scopedSlots: {customRender: "address"}
    },
    {
      title: "父亲姓名",
      dataIndex: "fatherName",
      customRender: (text, record, index) => {
        if (!record.fatherName) {
          return '-'
        } else {
          return record.fatherName
        }
      }
    },
    {
      title: "父亲手机号",
      dataIndex: "fatherPhone",
      customRender: (text, record, index) => {
        if (!record.fatherPhone) {
          return '-'
        } else {
          return record.fatherPhone
        }
      }
    },
    {
      title: "母亲姓名",
      dataIndex: "motherName",
      customRender: (text, record, index) => {
        if (!record.motherName) {
          return '-'
        } else {
          return record.motherName
        }
      }
    },
    {
      title: "母亲手机号",
      dataIndex: "motherPhone",
      customRender: (text, record, index) => {
        if (!record.motherPhone) {
          return '-'
        } else {
          return record.motherPhone
        }
      }
    },
    {
      title: "合并时间",
      dataIndex: "mergeTime",
      customRender: (text, record, index) => {
        if (!record.mergeTime) {
          return '-'
        } else {
          return record.mergeTime
        }
      }
    },
    {
      title: "合并操作人",
      dataIndex: "mergeUser",
      customRender: (text, record, index) => {
        if (!record.mergeUser) {
          return '-'
        } else {
          return record.mergeUser
        }
      }
    }
  ];

  export default {
    data() {
      return {
        mergeRecordData: [],
        data: [], //当前流程
        dateFormat: 'YYYY-MM-DD HH:mm:ss',
        datas: [], //历史流程
        data2: [], //样本信息
        detail: {}, //详细信息
        reason: "",
        finish: {},
        end: "",
        bid: "",
        review: "",
        visible: false,
        visible_reason: false,
        visible_finish: false,
        visible_refinish: false,
        visible_end: false,
        visible_review: false,
        visible_marge: false,
        columns,
        column,
        column2,
        columns3,
        id: "", //上一页面列表主键id
        process: 1, //1当前流程，2历史流程
        selectData: null,
        modelId: 0,
        pagination: false,
        spandIndex: null,
      };
    },
    components: {HProcess, Edit, Reason, Finish, End, Review, Refinish, Merge},
    mounted() {
      this.id = this.$route.query.id;
      this.getDetail();
      this.getData();
      this.getMergeRecord();
    },
    computed: {
      rowSelection() {
        const {selectedRowKeys} = this;
        return {
          onChange: (selectedRowKeys, selectedRows) => {

          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === "Disabled User", // Column configuration not to be checked
              name: record.name
            }
          })
        };
      }
    },
    methods: {
      merge() {
        this.visible_marge = true;
      },
      //获取患者合并历史
      getMergeRecord() {
        this.$get("patient/getPatientMergeHistory/" + this.id).then(res => {
          this.mergeRecordData = res.data.data;
        });
      },
      // 预览
      preview(uri) {
        let uploadFile = this.$db.get("uploadFile");
        window.open(uploadFile.fileHost + uri);
      },
      // 下载
      down(uri) {
        let uploadFile = this.$db.get("uploadFile");
        let upurl = uploadFile.fileHost + uri;
        this.$axios.get(upurl, {responseType: "blob"}).then(response => {
          let index = uri.lastIndexOf("/");
          let type = uri.substr(index);

          var blob = new Blob([response.data]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = type; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href);
          // }
        });

        // axios
        // .get(
        //   "http://10.61.102.148" + item.fileUrl,
        //   {},
        //   { responseType: "blob" }
        // )
        // .then(response => {
        //   var blob = new Blob([response.data]);
        //   var downloadElement = document.createElement("a");
        //   var href = window.URL.createObjectURL(blob); //创建下载的链接
        //   downloadElement.href = href;
        //   downloadElement.download = item.fileName; //下载后文件名
        //   document.body.appendChild(downloadElement);
        //   downloadElement.click(); //点击下载
        //   document.body.removeChild(downloadElement); //下载完成移除元素
        //   window.URL.revokeObjectURL(href); //释放掉blob对象
        // });
      },
      //获取详细信息
      getDetail() {
        this.$get("/patient/detail/" + this.id).then(res => {
          this.detail = res.data.data;
          this.bid = this.detail.id;
          this.getSampleData();
        });
      },
      goToSample(record) {
        this.$router.push({
          path: "/sample/detail",
          query: {
            id: record.id
          }
        });
      },
      //获取关联样本信息
      getSampleData() {
        this.$get("sampleinfo", {
          hosBarCode: this.detail.hosBarCode
        }).then(res => {
          this.data2 = res.data.data.rows;
        });
      },
      //获取当前流程
      getData() {
        this.$get(
          "/patientitem/patientItem/currentPatientItem?patientId=" + this.id
        ).then(res => {
          this.data = res.data.data;
          if (this.data.length > 0) {
            this.spandIndex = [this.data[0].id];
          }
        });
      },
      update() {
        this.getData();
        this.getDatas();
        this.getSampleData();
        // this.process = 2;
      },
      //获取历史流程
      getDatas() {
        this.$get("/patientitem/patientItem/historyPatientItem", {
          patientId: this.id,
        }).then(res => {
          this.datas = res.data.data;
          if (this.datas.length > 0) {
            this.spandIndex = [this.datas[0].id];
          }
        });
      },
      //展开行的回调

      expandedRowsChange(expandedRows) {
        if (expandedRows.length) {
          var arr = [];
          arr.push(expandedRows[expandedRows.length - 1]);
          this.spandIndex = arr;
        } else {
          this.spandIndex = [];
        }
      },
      //编辑个人信息
      edit() {
        this.detail = JSON.parse(JSON.stringify(this.detail));
        this.visible = true;
      },
      //关闭编辑弹框
      closeModel() {
        this.visible = false;
        this.visible_reason = false;
        this.visible_finish = false;
        this.visible_refinish = false;
        this.visible_end = false;
        this.visible_review = false;
        this.visible_marge = false;
      },
      //展示不合格原因
      showReason(data) {
        this.visible_reason = true;
        this.reason = data.sampleTypeName;
      },
      //确认完成
      finishIt(data) {
        this.finish = data;
        this.visible_finish = true;
      },
      //恢复流程
      refinishIt(data) {
        this.refinish = data;
        this.visible = false;
        this.visible_reason = false;
        this.visible_finish = false;
        this.visible_end = false;
        this.visible_review = false;
        this.visible_refinish = true;
      },
      //终止流程
      endIt(data) {
        this.end = data;
        this.visible_end = true;
      },
      //申请复审
      reviewIt(data) {
        this.review = data;
        this.visible_review = true;
      },

      //当前流程切换
      currentProcess() {
        this.process = 1;
        this.getData();
      },
      historyProcess() {
        this.process = 2;
        this.getDatas();
      }
    }
  };
</script>

<style lang="scss" scoped>
	/deep/ .ant-table {
		font-size: 12px;
	}

	.operate-more {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.ml {
		margin-left: 10px;
	}

	.mr {
		margin-right: 10px;
	}

	.sample-page {
		width: 100%;
		min-width: 1200px;

		.page-handle {
			height: 60px;
			background: #f8fbfb;
			padding: 0 40px;
			line-height: 60px;
			border-top: 1px solid rgba(240, 242, 245, 1);
			border-bottom: 1px solid rgba(240, 242, 245, 1);
			.right {
				float: right;
				height: 60px;
				.hospital-dropdown-link {
					margin-left: 25px;
				}
				.hospital-dropdown-link {
					color: #3e7ff7;
					font-size: 12px;
				}
			}
			.left {
				height: 60px;
				float: left;
				.ant-btn + .ant-btn {
					margin-left: 5px;
				}
			}
		}
		.page-content {
			padding: 0px 40px 40px 40px;
			background: #fff;
			.row-item {
				margin-bottom: 28px;
			}
			.panel-title {
				font-size: 16px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #a4a4a4;
				line-height: 59px;
				height: 59px;
				div {
					float: left;
					padding: 0px 57px 0 0;
					height: 16px;
					line-height: 16px;
					border-right: 1px solid #e1e2e5;
					margin-top: 22px;
					cursor: pointer;
				}
				div:last-child {
					border-right: none;
					padding: 0px 0 0 66px;
				}
				.active {
					font-weight: bold;
					color: #333;
				}
			}
			.panel-content {
				margin-top: 13px;
				background: rgba(249, 251, 251, 1);
				border: 1px solid rgba(240, 242, 245, 1);
				padding: 36px 0 0 0;
				.row-lable {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(164, 164, 164, 1);
				}
				.row-content {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);
					margin-left: 20px;
				}
			}
		}
	}

	.wei_detail {
		background: #fff;
		border: 1px solid #f0f2f5;
		margin-bottom: 29px;
		.content {
			padding: 20px 40px 30px 40px;
			.right-group {
				display: inline-block;
			}
			.ant-row + .ant-row {
				margin-top: 30px;
			}
		}
		.header {
			padding: 30px 40px;
			// padding-bottom: 18px;
			// border-bottom: 1px solid #f0f2f5;
			display: inline-block;
			width: 100%;
			.w-text-right {
				text-align: right;
			}
			.w-text-left {
				text-align: left;
			}
			.wei_header_box {
				.w-pb20 {
					padding-bottom: 20px;
				}

				margin-top: 28px;
				.right-group-title {
					display: inline-block;
					width: 100px;
					text-align: right;
				}
				.right-group-value {
					display: inline-block;
					min-width: 100px;
				}
				.rgv-min-width {
					min-width: 150px;
				}
			}
			.left {
				float: left;
			}
			.right {
				float: right;
				.right-group + .right-group {
					margin-left: 100px;
					margin-right: 18px;
				}
			}
			.name {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: bold;
				color: rgba(51, 51, 51, 1);
			}
			.sex {
				margin-left: 22px;
				.anticon {
					font-size: 16px;
					color: #428ef7;
				}
				.set-text {
					font-size: 12px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);
					margin-left: 6px;
				}
				.wei_soan_sex {
					cursor: pointer;
					color: #1890ff;
				}
			}
			.group {
				display: inline-block;
				height: 17px;
				font-size: 12px;
				padding: 0 10px;
				line-height: 17px;
				background: #428ef7;
				color: #fff;
				margin-left: 22px;
			}
			.create-date {
				margin-left: 70px;
				.title {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(164, 164, 164, 1);
				}
				.value {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);
					margin-left: 20px;
				}
			}
		}
	}

	.steps-div-content {
		background: #eef1f5;
		padding: 20px;
	}

	.blue {
		color: #1890ff;
	}
</style>